const record = {
    name: 'RECORD',
    type: 'product',
    logo: {
        image: 'https://firebasestorage.googleapis.com/v0/b/nme-website.appspot.com/o/brands%2Frecord.svg?alt=media&token=86389697-9bcd-4cbe-9c21-a38996013da7',
        height: '3.8em'
    },
    background: 'https://firebasestorage.googleapis.com/v0/b/nme-website.appspot.com/o/product%2Frecord%2Frecord-3.jpg?alt=media&token=6745d43e-bbeb-47a6-a7cf-6f53a32a01d8',
    heading: 'Explore the international manufacture of automatic sliding, telescopic, swing, folding and revolving doors.',
    blurb: 'World leader in the field of automatic door systems, RECORD benefits from over 60 years of experience offering hygienic and air-tight doors, burglar and fire-resistant doors, and break-out systems for the use in escape and rescue routes.',
    text: {
        1: "Using various thicknesses of tempered glass clamped together with specialist fittings, record offers almost any configuration of glass walls and entrance doors, especially in buildings where minimum framework is required, creating a minimalistic and elegant entrance solution.",
        2: "The innovation doesn't stop there. Where a streamlined look and clean lines are required, without compromising strength and operational efficiency, we can offer silent and invisible in-ground operators and in-head drives providing seamless elegance."
    },
    website: 'http://www.record.global',
    imageCount: '6',
    images: {
        1: 'https://firebasestorage.googleapis.com/v0/b/nme-website.appspot.com/o/product%2Frecord%2Fgallery%2F1.png?alt=media&token=70dd88bd-6f1f-4c8e-804c-821e3237afb1',
        2: 'https://firebasestorage.googleapis.com/v0/b/nme-website.appspot.com/o/product%2Frecord%2Fgallery%2F2.png?alt=media&token=79b66550-c178-4021-9b8c-b4e75a8b5168',
        3: 'https://firebasestorage.googleapis.com/v0/b/nme-website.appspot.com/o/product%2Frecord%2Fgallery%2F3.png?alt=media&token=3d0eba27-c01f-4ae9-8b17-c5c784f76165',
        4: 'https://firebasestorage.googleapis.com/v0/b/nme-website.appspot.com/o/product%2Frecord%2Fgallery%2F4.png?alt=media&token=ea078384-872e-4204-b32a-0606d21d245c',
        5: 'https://firebasestorage.googleapis.com/v0/b/nme-website.appspot.com/o/product%2Frecord%2Fgallery%2F5.png?alt=media&token=41a5924c-7aa4-46aa-9345-0d8bd46189ed',
        6: 'https://firebasestorage.googleapis.com/v0/b/nme-website.appspot.com/o/product%2Frecord%2Fgallery%2F6.png?alt=media&token=db4880f0-3463-41d5-ac74-8378fe3e7aed'
    }
};

export default record;



// WEBPACK FOOTER //
// ./src/data/product/record.js